import React from 'react';
import PointsData from '../Data/pointsData';

function PointsContainer({ unitName }) {
    function searchByName(searchTerm) {
        const searchTermLower = searchTerm.toLowerCase();
        return PointsData.filter((obj) =>
            obj.name.toLowerCase().includes(searchTermLower)
        );
    }

    function createTable(data) {
        return (
            <details className="mt-2  group">
                <summary className="flex  items-center  justify-end  gap-1  font-bold  list-none  opacity-50">
                    Points
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5  h-5  transition  group-open:rotate-180">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                    </svg>

                </summary>
                <div className="pb-3">
                    <table className="w-full  mt-2  border-collapse  border  border-slate-200">
                        <thead>
                            <tr>
                                <th className="px-2  py-1  border  border-slate-200  bg-slate-200  text-left">Models</th>
                                <th className="px-2  py-1  border  border-slate-200  bg-slate-200  text-left">Points</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((obj, index) => (
                                <React.Fragment key={index}>
                                    {obj.amount.map((amount, i) => (
                                        <tr key={i}>
                                            <td className="px-2  py-1  border  border-slate-200">{amount}</td>
                                            <td className="px-2  py-1  border  border-slate-200">{obj.points[i]}</td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </details>
        );
    }


    const searchResults = searchByName(unitName);
    const table = createTable(searchResults);

    return <div id="table-container">{table}</div>;
}

export default PointsContainer;
